import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { PermissionGroupResDTO } from 'src/models/permission';
import { userManagementAPIRoutes } from '..';

/**
 * PermissionServices is an API created using RTK Query's createApi function.
 * It provides endpoints for fetching permission groups based on merchant type.
 */
export const PermissionServices = createApi({
  reducerPath: 'permissionServices',
  tagTypes: ['PermissionTag'],
  baseQuery: fetchBaseQuery({
    baseUrl: userManagementAPIRoutes.baseUrl,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('jwtToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  endpoints: (builder) => ({
    /**
     * getPermission is an endpoint that fetches permission groups based on merchant type.
     */
    getPermission: builder.query<
      PermissionGroupResDTO[],
      {
        merchantType: string;
        roleId: number;
      }
    >({
      query: ({ merchantType, roleId }) => ({
        url: `${userManagementAPIRoutes.permissions.endpoint}?merchantType=${merchantType}&roleId=${roleId}`,
        method: 'GET'
      }),
      providesTags: ['PermissionTag']
    }),
    /**
     * saveRolePermissionMapping is an endpoint that saves the permission groups of a role.
     */
    saveRolePermissionMapping: builder.mutation<
      PermissionGroupResDTO[],
      {
        permissionGroupDTO: PermissionGroupResDTO[];
        roleId: number;
      }
    >({
      query: (body) => ({
        url: `${userManagementAPIRoutes.permissions.endpoint}/${userManagementAPIRoutes.permissions.saveRolePermissionMapping}`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['PermissionTag']
    })
  })
});
export const { useGetPermissionQuery, useSaveRolePermissionMappingMutation } =
  PermissionServices;
